import { combineReducers } from "redux";
import contactsReducer from "./contactsReducer";
import fieldsReducer from "./fieldsReducer";
import holidayHoursReducer from "./holidayHoursReducer";
import locationReducer from "./locationReducer";
import locationTypesReducer from "./locationTypesReducer";
import permissionsReducer from "./permissionsReducer";
import valuesReducer from "./valuesReducer";

export default combineReducers({
  contacts: contactsReducer,
  fields: fieldsReducer,
  holidayHours: holidayHoursReducer,
  location: locationReducer,
  locationTypes: locationTypesReducer,
  permissions: permissionsReducer,
  values: valuesReducer,
});
